import { actionTypes } from "../../actions/action_types";

const initialState = {
  package_list: [],
};

export default function package_reducer(state = initialState, action) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.REPORTS_PACKAGE_GET_OVERALL:
      stateCopy.package_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_PACKAGE_GET_CLUSTER:
      stateCopy.package_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_PACKAGE_GET_AREA:
      stateCopy.package_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_PACKAGE_GET_BRANCH:
      stateCopy.package_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_DAILY_PACKAGE_GET_OVERALL:
      stateCopy.package_list = action.payload.packageSummaries;
      return stateCopy;

    case actionTypes.REPORTS_DAILY_PACKAGE_GET_CLUSTER:
      stateCopy.package_list = action.payload.packageSummaries;
      return stateCopy;

    case actionTypes.REPORTS_DAILY_PACKAGE_GET_AREA:
      stateCopy.package_list = action.payload.packageSummaries;
      return stateCopy;

    case actionTypes.REPORTS_DAILY_PACKAGE_GET_BRANCH:
      stateCopy.package_list = action.payload.packageSummaries;
      return stateCopy;

    default:
      return state;
  }
}
